import angular from 'angular';
import './resource';

const module = angular.module('whyline.resources.application', [
  'whyline.resources.resource',
]);

const ApplicationFactory = ($http, API_URL, Resource) => {
  /*@ngInject*/

  const _type = 'application';
  const apiEndPoint = `${API_URL}${_type}`;

  const _schema = {
    version: String
  };

  const Application = function(data) {
    angular.forEach(_schema, (prop, key) => {
      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });
  };

  Application.GetServerVersion = () => {
    const url = `${apiEndPoint}/server-version`;
    return $http.get(url);
  };

  Application.prototype = new Resource(_type, _schema, Application);

  Resource.Extend(_type, Application);

  const validityTime = 10 * 60 * 1000;

  Application.InitCache(validityTime);

  return Application;
};

module.exports = module.factory('Application', ApplicationFactory);